import { Settings } from 'luxon';

export function setDateTimeLocalization() {
  Settings.defaultLocale = 'en-GB';
}
